import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'invoiceStatus',
})
export class InvoiceStatusPipe implements PipeTransform {

  private map: any = {
    D: { label: 'Draft', class: 'chip-draft' },

    P: { label: 'Awaiting Approval', class: 'chip-awaiting-approval' },

    A: { label: 'Awaiting Verification', class: 'chip-awaiting-verification' },

    V: { label: 'Unpaid', class: 'chip-unpaid' },

    T: { label: 'Partially Paid', class: 'chip-partially-paid' },

    I: { label: 'Added to Payment', class: 'chip-added' },

    F: { label: 'Paid', class: 'chip-paid' },

    R: { label: 'Rejected', class: 'chip-rejected' },

    O: { label: 'Overdue', class: 'chip-overdue' },

    C: { label: 'Cancelled', class: 'chip-cancelled' },
  };

  transform(value: string, type: 'label' | 'class'): string {
    return this.map[value]?.[type] || '';
  }

}
